import React, { FC } from 'react';
import { ListingCardLocation } from 'src/common/types/common/ListingCard';
import classNames from 'classnames';
import getClassNames from '../../utils/getClassNames';
import ListingFavoriteButton from '../ListingFavoriteButton';

import styles from './ListingCardOverview.module.scss';

export type Props = {
  listingId: string;
  heading: string;
  guests?: string;
  isHighlighted?: boolean;
  cardLocation?: ListingCardLocation;
  withFavorite?: boolean;
  /** ListingCard variant shown in Map view */
  isPopup?: boolean;
};

const ListingCardOverview: FC<Props> = ({
  listingId,
  guests,
  heading,
  isHighlighted,
  cardLocation,
  withFavorite = true,
  isPopup = false,
}) => (
  <div className={getClassNames(styles, 'root', classNames({ popup: isPopup }))}>
    <div className={styles.overview}>
      {heading && (
        <span className={styles.heading}>
          {heading}
        </span>
      )}
      {heading && guests && (' · ')}
      {guests && (
        <span className={styles.guests}>
          {guests}
        </span>
      )}
    </div>
    {withFavorite && (
      <ListingFavoriteButton
        listingId={listingId}
        isHighlighted={isHighlighted}
        cardLocation={cardLocation}
        iconSize="s"
      />
    )}
  </div>
);

export default ListingCardOverview;
